import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Floating {

  #rmp;
  #floatingViewablePreviousRatio = 0.5;
  #floatingFirstView = false;
  #floatingViewableObserver = null;
  #onClosingFloatingClickfn = null;
  #floatingPlayerIsAnchored = true;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get isAnchored() {
    return this.#floatingPlayerIsAnchored;
  }

  #handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > this.#floatingViewablePreviousRatio) {
        Logger.print('floating', 'player comes into view');
        // we do not want to detach player before viewer has scrolled to it at least once
        if (!this.#floatingFirstView) {
          this.#floatingFirstView = true;
        }
        if (!this.#floatingPlayerIsAnchored) {
          this.attachPlayer();
        }
      } else {
        Logger.print('floating', 'player comes out of view');
        if (this.#floatingPlayerIsAnchored && this.#floatingFirstView) {
          this.detachPlayer();
        }
      }
      this.#floatingViewablePreviousRatio = entry.intersectionRatio;
    });
  }

  #onClosingFloatingClick(event) {
    FW.eventStopPrevent(event);
    Logger.print('floating', 'cancelling floating at user request');
    this.#floatingViewableObserver.disconnect();
    this.attachPlayer();
    FW.removeElement(this.#rmp.dom.floating);
  }

  #attachClosingButton() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('floating');
    this.#onClosingFloatingClickfn = this.#onClosingFloatingClick.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.floating, this.#onClosingFloatingClickfn);
  }

  #onReadySetUpObserver() {
    Logger.print('floating', 'attaching observer');
    if (typeof IntersectionObserver !== 'undefined') {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: this.#rmp.floatingThreshold
      };
      this.#floatingViewableObserver = new IntersectionObserver(this.#handleIntersect.bind(this), options);
      this.#floatingViewableObserver.observe(this.#rmp.dom.floatingAnchorElement);
      this.#attachClosingButton();
    }
  }

  // run when the player should detach
  detachPlayer() {
    Logger.print('floating', 'detaching player from anchor');
    this.#floatingPlayerIsAnchored = false;
    this.#rmp.dom.container.classList.add('rmp-detach');
    this.#rmp.resize();
    this.#rmp.dispatch('floating');
  }

  // run when the player should be attached to its original location
  attachPlayer() {
    Logger.print('floating', 'attaching player to anchor');
    this.#floatingPlayerIsAnchored = true;
    this.#rmp.dom.container.classList.remove('rmp-detach');
    this.#rmp.resize();
    this.#rmp.dispatch('unfloating');
  }

  init() {
    Logger.print('floating', 'init');
    this.#rmp.dom.floatingAnchorElement = document.getElementById('rmp-anchor-element');
    if (!this.#rmp.dom.floatingAnchorElement) {
      this.#rmp.rmpUtils.warning(14000);
      return;
    }
    if (this.#rmp.posterUri) {
      this.#rmp.dom.floatingAnchorElement.style.backgroundImage = 'url(' + this.#rmp.posterUri + ')';
    }
    this.#rmp.one('ready', this.#onReadySetUpObserver.bind(this));
  }

}
